export { CommandPalette } from './CommandPalette';
export { createCommandHelper } from './createCommandHelper';

export { isAccessoryCount, isIconConfig } from './types';
export type {
    AccessoryCount,
    CommandConfirmation,
    CommandContext,
    CommandDefinition,
    CommandIcon,
    CommandPaletteProps,
    QuickLookConfig,
} from './types';

// The global palette's old import path, kept for existing imports.
export { GlobalCommandPalette, GlobalCommandPaletteInput } from '../../CommandPalette';
export type {
    GlobalCommandContext,
    GlobalCommandDefinition,
    GlobalCommandPaletteInputProps,
    GlobalCommandPaletteProps,
    SearchableResource,
} from '../../CommandPalette';
